export class ClassToggle {
  constructor() {
    this.execute();
  }

  execute = () => {
    const toggleElems = document.querySelectorAll(".js-toggle-item");

    toggleElems.forEach((toggleElem) => {
      // SP限定などの例外（必要なら残す）
      if (toggleElem.classList.contains("js-toggle-item__sp") && window.innerWidth >= 1024) return;

      const btn = toggleElem.querySelector(".toggle-btn");
      const panel = toggleElem.querySelector(".toggle-con");
      if (!btn || !panel) return;

      const sync = (isOpen) => {
        toggleElem.classList.toggle("is-open", isOpen);
        btn.setAttribute("aria-expanded", String(isOpen));
        panel.setAttribute("aria-hidden", String(!isOpen));
      };
      // 初期状態同期（is-open付いてたら開く）
      sync(toggleElem.classList.contains("is-open"));

      btn.addEventListener("click", (e) => {
        if (btn.tagName === "A") {
          e.preventDefault();
        }
        const isOpen = !toggleElem.classList.contains("is-open");
        console.log(isOpen);
        sync(isOpen);
        //sync = synchronize（同期する）
      });
    });
  };
}
